import axios from 'axios'
import constants from '../lib/constants'

// CONSTANTS
export const GET_SITES = 'GET_SITES'
export const GET_SITES_COMPLETE = 'GET_SITES_COMPLETE'
export const CREATE_SITE = 'CREATE_SITE'
export const CREATE_SITE_COMPLETE = 'CREATE_SITE_COMPLETE'
export const GET_PATIENTS = 'GET_PATIENTS'
export const GET_PATIENTS_COMPLETE = 'GET_PATIENTS_COMPLETE'
export const UPDATE_SITE = 'UPDATE_SITE'
export const UPDATE_SITE_COMPLETE = 'UPDATE_SITE_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getSites = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_SITES })
    return axios.get(`${constants.API_URL}/sites/list`)
    .then((response) => {
      const sortedSites = response.data.sites.sort((a, b) => (a.name > b.name ? 1 : -1))
      dispatch({
        type    : GET_SITES_COMPLETE,
        payload : {
          sites: sortedSites,
        }
      })
      return response
    })
  }
}

export const updateSite = (updatedSite) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_SITE })
    return axios.post(`${constants.API_URL}/sites/${updatedSite.id}/update`, updatedSite)
    .then((response) => {
      const updatedSite = response.data
      dispatch({
        type    : UPDATE_SITE_COMPLETE,
        payload : {
          updatedSite: updatedSite
        }
      })
      return response
    })
  }
}


export const createSite = (name, address, organizationId, pharmacyId, userId, testStripCount) => {
  return (dispatch) => {
    dispatch({ type: CREATE_SITE })
    return axios.post(`${constants.API_URL}/sites/create`,
      {
        name,
        address,
        organization_id: organizationId,
        pharmacy_id: pharmacyId,
        user_id: userId,
        test_strip_count: testStripCount || null,
      }
    )
    .then((response) => {
      const newSite = response.data
      dispatch({
        type    : CREATE_SITE_COMPLETE,
        payload : {
          createdSite: newSite
        }
      })
      return response
    })
  }
}

export const associateDeviceWithSite = (siteId, deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/sites/${siteId}/associate_device`, {
      device_string: deviceString,
    })
  }
}

export const dissociateDeviceWithSite = (siteId, deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/sites/${siteId}/dissociate_device`, {
      device_string: deviceString,
    })
  }
}



// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_SITES_COMPLETE] : (state, action) => {
    const { sites } = action.payload
    const newState = {
      ...state,
      sites
    }
    return newState
  },
  [CREATE_SITE_COMPLETE] : (state, action) => {
    const { createdSite } = action.payload
    const newState = {
      ...state,
      createdSite
    }
    return newState
  },
  [UPDATE_SITE_COMPLETE] : (state, action) => {
    const { updatedSite } = action.payload
    const newState = {
      ...state,
      createdSite: updatedSite
    }
    return newState
  }
}

// REDUCER

const initialState = {
  sites: [],
  createdSite: null,
}

export default function sitesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/sites.js